<template>
  <div class="main" :style="`background: url(${bg})`">
    <div style="zoom: 2">
      <h3>“码上办”线上受理登记</h3>
      <div class="main_content">
        <div class="form_item">
          <p class="item_title"><span>*</span>统一社会代码</p>
          <div class="item_input">
            <el-input
              v-model="form.enterpriseCode"
              placeholder="请输入统一社会信用代码"
            ></el-input>
          </div>
        </div>
        <div class="form_item">
          <p class="item_title"><span>*</span>企业名称</p>
          <div class="item_input">
            <el-input
              v-model="form.enterpriseName"
              placeholder="请输入企业名称"
            ></el-input>
          </div>
        </div>
        <div class="form_item">
          <p class="item_title"><span>*</span>办理区域</p>
          <div class="item_input">
            <el-radio-group v-model="form.handlingArea">
              <el-radio
                :label="item.value"
                v-for="item in options"
                :key="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
        <div class="form_item">
          <p class="item_title"><span>*</span>部门</p>
          <div class="item_input">
            <el-input
              v-model="form.department"
              placeholder="示例：咸宁市市民服务中心"
            ></el-input>
          </div>
        </div>
        <div class="form_item">
          <p class="item_title"><span>*</span>具体情况描述</p>
          <p class="item_tips">
            “码上办”问题受理范围:受理企业群众反映的在部门办理行政审批及公共服务事项过程中，线上或线下提交申请材料后，未能实现成功受理、成功审批或多次来部门未能解决等问题（涉法、涉诉、涉访及与当前政策规定不符的事项除外）
          </p>
          <div class="item_input">
            <el-input
              v-model="form.description"
              type="textarea"
              :autosize="{ minRows: 6 }"
              placeholder="请输入具体情况描述"
            ></el-input>
          </div>
        </div>
        <div class="form_item">
          <p class="item_title">意见或建议</p>
          <div class="item_input">
            <el-input
              v-model="form.opinion"
              type="textarea"
              :autosize="{ minRows: 6 }"
              placeholder="请输入意见或建议"
            ></el-input>
          </div>
        </div>
        <div class="type" style="text-align: center">
          <el-button style="width: 50%" type="primary" @click="onSubmit"
            >提交</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="提交成功"
      :visible.sync="centerDialogVisible"
      width="80%"
      center
    >
      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="goto">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import bg from "./img/bg.png";
export default {
  data() {
    return {
      bg,
      form: {},
      options: [
        {
          value: "咸宁市",
          label: "咸宁市",
        },
        {
          value: "赤壁市",
          label: "赤壁市",
        },
        {
          value: "咸安区",
          label: "咸安区",
        },
        {
          value: "嘉鱼县",
          label: "嘉鱼县",
        },
        {
          value: "崇阳县",
          label: "崇阳县",
        },
        {
          value: "通城县",
          label: "通城县",
        },
        {
          value: "通山县",
          label: "通山县",
        },

        {
          value: "外地",
          label: "外地",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],
      centerDialogVisible: false,
    };
  },
  methods: {
    onSubmit() {
      let keys = [
        "enterpriseCode",
        "enterpriseName",
        "handlingArea",
        "department",
        "description",
        // "opinion",
      ];
      for (let item of keys) {
        if (!this.form[item]) {
          this.$message({
            type: "warning",
            message: "请完善表单信息！",
          });
          return;
        }
      }
      this.$api.codeHandle.create(this.form).then(() => {
        // this.$message({
        //   type: "success",
        //   message: "操作成功！",
        // });
        this.centerDialogVisible = true;
      });
    },
    goto() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  overflow: auto;
  background-size: cover;

  h3 {
    color: #fff;
    text-align: center;
    margin-top: 38px;
    font-size: 24px;
  }

  .main_content {
    background: #fff;
    padding: 15px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-top: 20px;

    .form_item {
      margin-bottom: 15px;
      .item_tips {
        color: #cac8c8;
        font-size: 12px;
        line-height: 18px;
        margin: 5px;
      }
      .item_title {
        span {
          display: inline-block;
          color: red;
          margin-right: 5px;
        }
      }

      .item_input {
        margin-top: 5px;
      }
    }
  }
}

::v-deep .el-input__inner {
  background-color: #f5f7fd;
  border: none;
}
::v-deep .el-textarea__inner {
  background-color: #f5f7fd;
  border: none;
  font-size: 12px;
}

::v-deep .el-radio {
  margin-bottom: 5px;
}

.main_container {
  background: #fafafa;
  height: 100vh;
  overflow: auto;
  zoom: 1.5;

  .content {
    margin: 20px;
    padding: 20px;
    border-radius: 10px;
    background: #fff;

    .tip {
      line-height: 20px;
      display: inherit;
    }

    h3 {
      margin: 10px 0 20px;
      text-align: center;
    }
  }
}
</style>